import React, { useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Col } from 'antd';
import TagInstallationInstructionsModal from '../../details/components/TagInstallationInstructionsModal';
import '../../styles/index.scss';

const DocumentationAlert = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Col xs={23} lg={23} className="tags-alert__col">
        <Alert
          description={
            <>
              <h4>
                <InfoCircleOutlined className="tags-alert__icon" />
                Please ensure that the tags below are installed on the{' '}
                <a
                  className="tags-alert__link"
                  href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/header"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  header section{' '}
                </a>
                on all pages of your website. Click{' '}
                <a
                  className="tags-alert__link"
                  onClick={() => setIsModalVisible(true)}
                >
                  here
                </a>{' '}
                for more comprehensive instructions.
              </h4>
            </>
          }
        />
        <TagInstallationInstructionsModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
        />
      </Col>
    </>
  );
};

export default DocumentationAlert;
